<template>
  <div>

    <el-card style=" margin: 20px 20px">

      <el-form :model="form" label-width="100px">
        <el-form-item label="单位：">
          <base-select v-model="form.organizationId" :search-fn="organizationApi.list" disabled
                       style="width: 300px;"></base-select>
        </el-form-item>

        <el-form-item label="签名：">
          <el-upload
              ref="upload"
              :action="apiPath"
              :before-upload="beforeAvatarUpload"
              :on-success="handleAvatarSuccess"
              :show-file-list="false"
              accept=".jpg,.jpeg,.png,.bmp"
              class="avatar-uploader">
            <img v-if="imageUrl" :src="imageUrl" style="height: 40px;">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="提示：">
          <span style="color:red">上传签名图片大小不能超过 2MB</span>
        </el-form-item>
        <el-form-item label="样例：">
          <el-image
              :initial-index="0"
              :max-scale="7"
              :min-scale="0.2"
              :preview-src-list="[example]"
              :src="example"
              :zoom-rate="1.2"
              fit="cover"
              show-progress
              style="height:40px"
          />
        </el-form-item>
        <el-button style="margin-left: 50px;" type="primary" @click="handleSave">保存</el-button>
        <el-button style="margin-left: 50px;" type="danger" @click="handleDelete">删除</el-button>
      </el-form>


    </el-card>
  </div>
</template>

<script>
import pagination from "@/components/Pagination"
import BaseSelect from "@/components/BaseSelect";
import * as userApi from "@/api/gen/userApi"
import * as organizationApi from "@/api/gen/organizationApi"
import * as roleApi from "@/api/gen/roleApi"

export default {
  components: {
    BaseSelect,

    pagination,
  },
  name: "sign",
  data() {
    return {
      roleApi,
      organizationApi,
      example: 'https://tuan002.oss-cn-shenzhen.aliyuncs.com/stamp/26bb12ac-a923-4890-8ccd-552554d699bd.png',
      form: {
        organizationId: this.$store.getters.organizationId,
        username: "",
        name: "",
        user: '',
        roleIds: '',

      },
      apiPath: `${process.env.VUE_APP_API}` + "/oss/upload/stampFile",
      total: 0,
      List: [],
      isEditShow: false,
      isUpdateDialog: false,
      isRoleAdmin: false,
      current: {},
      roleList: [],
      imageUrl: "",
      organizationInfo: {}
    }
  },

  watch: {

    form: {
      deep: true,
      handler() {
        this.handList()
      }
    },


  },
  created() {
    this.list()
    //防抖
    this.handList = this._.debounce(this.list, 600)
    this.getOrgInfo()
  },
  computed: {},
  methods: {
    async getOrgInfo() {
      const res = (await organizationApi.getById({id: this.form.organizationId}))
      if (res.signFile != null && res.signFile != "") {
        this.imageUrl = res.signFile
      }
      this.organizationInfo = res
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
      this.organizationInfo.signFile = res.data.name
    },

    async handleDelete() {
      this.organizationInfo.signFile = ""
      this.imageUrl = ""
      const res = (await organizationApi.update({...this.organizationInfo}))
      this.$message({
        type: "success",
        message: "删除成功"
      })
    },

    async handleSave() {
      const res = (await organizationApi.update({...this.organizationInfo}))
      this.$message({
        type: "success",
        message: "保存成功"
      })
    },

    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('上传签名图片大小不能超过 2MB!');
      }
      return isLt2M;
    },

    async addDialogShow() {
      this.isEditShow = true
      this.current = {};
    },
    updateDialog(data) {
      this.isEditShow = true
      this.current = data;
    },
    roleAdminDialog(data) {
      this.current = data;
      this.isRoleAdmin = true
    },


    //删除
    remove(id) {
      this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        showClose: false,
        distinguishCancelAndClose: true,
        center: true
      }).then(async () => {

        await userApi.deleteById({id: id})
        this.$message({
          type: "success",
          message: "删除成功"
        })

        await this.list()

      }).catch((err) => {

      })


    },


    //禁用

    async change(data, e) {
      console.log(data, e)
      let params = {
        id: data.id,
        status: e
      }
      await userApi.update({...params})

    },


    //列表 搜索
    async list() {
      let clone = {...this.form}
      if (this.form.roleIds) {
        clone.roleIds = clone.roleIds + ','
      }
      const res = (await userApi.list({...clone, pageSize: 100000}));


      for (let index in res.data) {
        if (res.data[index].username === 'adminuser') {
          res.data.splice(index, 1)
        }

      }

      this.List = res.data

      console.log(res)

    },


    async role() {
      let res = await roleApi.list()
      this.roleList = res.data
    },


    findRole(arr) {
      let array = []
      this.roleList.forEach(item => {
        arr.find((val) => {
          if (val === item.id) {
            return array.push(item.name)
          }
        })

      })

      array = array.join('、')
      return array
    },


  },
  mounted() {
    // this.role()
  }

}
</script>

<style scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
